import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setUserProperties, isSupported } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getRemoteConfig, fetchAndActivate, getValue } from "firebase/remote-config";

const firebaseConfig = {
  apiKey: "AIzaSyDho9_zMgi5vyaQIJlO_WsvxgYOlE3-Y4A",
  authDomain: "skilful-module-87217.firebaseapp.com",
  databaseURL: "https://skilful-module-87217.firebaseio.com",
  projectId: "skilful-module-87217",
  storageBucket: "skilful-module-87217.firebasestorage.app",
  messagingSenderId: "430182218514",
  appId: "1:430182218514:web:32d730582e6ebf5ad0d1cb",
  measurementId: "G-9PXSXLB8PE"
};

const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);
const messaging = getMessaging(app);
const remoteConfig = getRemoteConfig(app);

remoteConfig.settings.minimumFetchIntervalMillis = 15000;

if (process.env.NODE_ENV !== 'production') {
  window.gtag('config', 'G-9PXSXLB8PE', {
    debug_mode: true,
  });
}

const analyticsPromise = isSupported()
  .then((ok) => (ok ? getAnalytics(app) : null))
  .catch(() => null);

const requestPermission = async () => {
  const permission = await Notification.requestPermission();
  if (permission == 'granted') {
    return true;
  }
  return false;
}

const getRemoteConfigValue = async (key) => {
  try {
    await fetchAndActivate(remoteConfig);
    const value = getValue(remoteConfig, key);
    return {
      asBoolean: () => value.asBoolean(),
      asNumber: () => value.asNumber(),
      asString: () => value.asString(),
      asJSON: () => {
        try {
          return JSON.parse(value.asString());
        } catch (error) {
          console.error(`Remote Config: Erro ao parsear JSON para ${key}`, error);
          return null;
        }
      },
    };
  } catch (error) {
    console.error(`Remote Config: Erro ao obter valor para ${key}`, error);
    return null;
  }
}

async function setAnalyticsUserProps (props = {}) {
  const analytics = await analyticsPromise;
  if (!analytics) {
    return;
  }
  setUserProperties(analytics, props);
}

async function setLocalidadeEstabelecimento ({ localidade, localidade_id, estabelecimento_id } = {}) {
  const props = {};
  if (localidade) {
    props.localidade = String(localidade);
  }
  if (localidade_id) {
    props.localidade_id = String(localidade_id);
  }
  if (estabelecimento_id) {
    props.loja_id = String(estabelecimento_id);
  }

  await setAnalyticsUserProps(props);

  const analytics = await analyticsPromise;
  if (analytics) {
    logEvent(analytics, 'selected_store', {
      localidade: props.localidade || '',
      localidade_id: props.localidade_id || '',
      loja_id: props.loja_id || '',
      timestamp: new Date().getTime(),
    });

    logEvent(analytics, 'user_property_update', {
      property_type: 'selected_store',
    });
  }
}

async function clearLocalidadeEstabelecimento () {
  await setAnalyticsUserProps({
    localidade: null,
    localidade_id: null,
    loja_id: null,
  });

  const analytics = await analyticsPromise;
  if (analytics) {
    logEvent(analytics, 'selected_store', {
      action: 'user_properties_cleared',
    });
  }
}

onMessage(messaging, (payload) => {
  console.log('Message received. ', payload);
});

export default {
  app,
  analyticsPromise,
  setAnalyticsUserProps,
  setLocalidadeEstabelecimento,
  clearLocalidadeEstabelecimento,
  messaging,
  analytics,
  remoteConfig,
  getToken : async () => {
    const permission = await requestPermission();
    return permission ? await getToken(messaging, {vapidKey: 'BAfq0KwEfOLwYUZK5yAnD-JEdOvhhWNU4WhQCQ6bRG9jZuUEo37G76jDQ_Wbj7XveYf4L5P9avSvWd87rZWRLv0'}) : null
  },
  getRemoteConfigValue,
  logEvent: async (name, params) => {
    const analytics = await analyticsPromise;
    if (!analytics) {
      return;
    }
    logEvent(analytics, name, params);
  },
};
